// extracted by mini-css-extract-plugin
export default {"fullscreenBottom":"dg_lz","wrapper":"dg_dt","thumbnails":"dg_lB","thumbnail":"dg_lC","image":"dg_dx","isActive":"dg_hd"};